// Public references must be random UUID v4 values issued by the backend.
// A valid shape is not an authorization check; no internal ID is encoded here.
export function isPublicAgencyId(value) {
    return typeof value === 'string'
        && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(value);
}

export function getAgencyUrl(publicId) {
    return isPublicAgencyId(publicId) ? `/info/${publicId}` : undefined;
}

// Persist only public presentation fields, never an internal ID from an API or old cache.
export function toPublicAgencyCard(card) {
    if (!card || !isPublicAgencyId(card.publicId)) return null;
    const fields = ['publicId', 'name', 'since', 'location', 'isFuneralHomeAvailable', 'phone', 'email', 'searchLocation'];
    return Object.fromEntries(fields.filter(field => Object.prototype.hasOwnProperty.call(card, field)).map(field => [field, card[field]]));
}
